			
const messages = {
	/*  form error messgaes for bride  */
	// EMAIL_MUST_BE_VALID:"Email must be valid",

	PLEASE_SELECT:"Please Select",

	FIRM_NAME_ERROR:"Firm Name can not be empty" ,
	NAME_ERROR:"Name can not be empty" ,
	MOBILE_NUMBER_ERROR:"Mobile Number can not be empty" ,
	INVALID_MOBILE_NUMBER_ERROR:"Mobile number must be valid",

	PHONE_NUMBER_ERROR:"Phone Number can not be empty" ,
	INVALID_PHONE_NUMBER_ERROR:"Phone number must be valid",

	LANDLINE_NUMBER_ERROR:"Landline number can not be empty" ,
	INVALID_LANDLINE_NUMBER_ERROR:"Landline number must be  valid" ,
	EMAIL_ERROR:"Email ID can not be empty" ,
	EMAIL_MUST_BE_VALID:"Email ID must be valid",
	PASSWORD_ERROR:"Password can not be empty" ,
	CONFIRM_PASSWORD_ERROR:"Confirm Password can not be empty" ,
	PASSWORD_MISMATCH_ERROR:"Password not match",
	PIN_CODE_ERROR:"Pin code can not be empty",
	FULL_ADDRESS_ERROR:"Full Address can not be empty" ,
	CITY_ERROR:"City can not be empty" ,
	STATE_ERROR:"State can not be empty" ,
	GST_NUMBER_ERROR:"GST number can not be empty",
	INVALID_GST_NUMBER_ERROR:"GST number must be valid",
	AREA_ERROR:"Area can not be empty",

	AADHAAR_NUMBER_ERROR:"Aadhaar number can not be empty",
	INVALID_AADHAAR_NUMBER_ERROR:"Aadhaar number must be valid",

	USER_NAME_ERROR:"User name can not br empty",

	RETAILER_ERROR:"Please Select retailer",
	WHOLESALER_ERROR:"Please Select wholesaler",
	CHALLAN_NUMBER_ERROR:"Challan number can not be empty",
	AMOUNT_ERROR:"Amount can not be empty",
	AMOUNT_MUST_BE_ERROR:"Amount must be Number",
	NO_OF_PACKET_ERROR:"Number of packets can not be less than 1",
	LINE_ERROR:"Line can not be empty",
	PLAN_ERROR:"Please Select Subscription Plan",



	SHIPMENT_ID_ERROR:"Shipment ID can not be empty" ,
	DESCRIPTION_ERROR:"Shipment ID can not be empty" ,
	CATEGORY_ERROR:"Please select Category" ,


	PRODUCT_NAME_ERROR:"Product Name can not be empty" ,
	MANUFACTURER_ERROR:"Manufacturer can not be empty" ,
	FARMULA_ERROR:"Farmula can not be empty",
	OFFER_ERROR:"Invalid input for Offer",

	DL_ERROR:"Driving license number can not be empty",
	INVALID_DL_ERROR:"Driving license number must be valid",

	BANK_NAME_ERROR:"Bank name can not be empty",
	ACCOUNT_HOLDER_NAME_ERROR:"Account holder name can not be empty",
	IFSC_ERROR:"IFSC code can not be empty",
	ACCOUNT_NUMBER_ERROR:"Account number can not be empty",
	INVALID_ACCOUNT_NUMBER_ERROR:"Account number must be number",

	PAN_ERROR:"PAN number can not be empty",
	INVALID_PAN:"PAN number must be valid",

	CREDIT_LIMIT_ERROR:"Credit limit can not be empty",
	INVALID_CREDIT_LIMIT:"Credit limit must be valid",
	GST_ERROR:"GST can not be empty",
	GST_INVALID:"GST must be Number",
	PRICE_ERROR:"Price can not be empty",
	PRICE_INVALID:"Price must be Number",
	MRP_ERROR:"MRP can not be empty",
	MRP_INVALID:"MRP must be Number",
	DAYS_ERROR:"Days can not be empty",
	DAYS_INVALID:"Days must be Number",
	DL_EXPIRY_ERROR:"Driving licence expiry date can not be empty",


	RECIPIENT_NAME_ERROR:"Recipient name can not be empty",
	WAREHOUSE_NAME_ERROR:"Warehouse name can not be empty",
	WAREHOUSE_ERROR:"Warehouse can not be empty",

	LINE_NAME_ERROR:"Line name can not be empty",
	LINE_ID_ERROR:"Line id can not be empty",
	DELIVERY_TIME_ERROR:"Delivery time can not be empty",
	SHIPMENT_COUNT_ERROR:"Number of shipment must be Number",

	NUMBER_ERROR:"This filed can not be empty",
	NUMBER_INVALID:"input must be Number",

	CHEQUE_NUMBER_ERROR:"Cheque number can not be empty",
	NEFT_TRANSACTION_ID_ERROR:"NEFT transaction id can not be empty",


	/* success/error message */

	PROFILE_SAVED:"Profile Saved" ,
	INVALID_FILE:"Invalid file formate",
	MAX_FILE_SIZE_ERROR:"Cannot upload a file larger than",
	MULTIPLE_FILE_NOT_SUPPORTED:"Multiple file not supported",
	FILE_UPLOADED:"File Uploaded",

	SELECT_AGENT_TYPE:"Select Agent Type",
	TYPE_ERROR:"Type can  not be emptym",
	NO_SHIPMENT_SELECTED:"No Shipment selected",
	MAX_SHIPMENT_SELECTED:"You can select maximum 8 shipment at a time",
	NO_ITEM_SELECTED:"No Item selected",
	NO_TRANSACTION_SELECTED:"No Transaction  selected",

	SLELECT_LOCATION:"Please Select you location",
	subscription_success_msg:"success msg here",

	MATCHING_PHONE_NUMBER_ERROR:"Please use different Phone number",

	INITIATE_PAYOUT_SUCCESS_MSG:"Payoute Initiated",


	NOTE_FOR_MANUAL_STATUS_CHANGE:"This shipment will be considers as return because of manual changes in shipment status.",

}

export default messages	